import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  CircularProgress,
  InputAdornment,
  TextField,
  Box,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import { useEffect, useState } from "react";
import { UrlApi } from "../../../../../../../services/apirest";
import { logEventos } from "../../../../../../../services/services";

const MaximoRedondeoModal = ({
  open,
  onClose,
  valorRedondeoActual,
  showToast,
}) => {
  const [valorRedondeo, setValorRedondeo] = useState("");
  const [loading, setLoading] = useState(false);

  const user = localStorage.getItem("user");

  useEffect(() => {
    setValorRedondeo(valorRedondeoActual);
  }, [valorRedondeoActual]);

  const handleConfirm = async () => {
    setLoading(true);

    try {
      await fetch(
        `${UrlApi}/ctacte/recibos/actualizarMaximo/redondeo/${valorRedondeo}/${user}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        },
      );
      logEventos(
        `Se cambio el valor del redondeo. Valor anterior: ${valorRedondeoActual}. Nuevo valor: ${valorRedondeo}`,
        "Recibos pendientes",
        "Cambio en el valor de redondeo",
        localStorage.getItem("user"),
      );
      showToast(
        "El valor maximo del redondeo se actualizo correctamente",
        "success",
      );
      onClose();
    } catch (error) {
      showToast(
        "Ocurrio un error al actualizar el precio del redondeo",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 3,
          py: 2,
          background: "linear-gradient(135deg, #2563eb, #3b82f6)",
          color: "white",
        }}
      >
        <TuneIcon />
        <Typography fontWeight="bold" fontSize={18}>
          Configurar redondeo
        </Typography>
      </Box>

      {/* CONTENT */}
      <DialogContent sx={{ px: 3, py: 3 }}>
        <Typography fontSize={14} color="text.secondary" mb={2}>
          Definí el monto máximo permitido para redondeos en los recibos.
        </Typography>

        {/* INPUT */}
        <TextField
          fullWidth
          label="Nuevo máximo"
          type="number"
          value={valorRedondeo}
          onChange={(e) => setValorRedondeo(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
          }}
        />
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
          }}
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={loading || !valorRedondeo}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: "bold",
            minWidth: "120px",
          }}
        >
          {loading ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            "Guardar cambios"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MaximoRedondeoModal;
